import AppCustomIcon from '@/app/features/icon/AppIcon';
import { SxProps, useTheme, Box } from '@mui/material';
import React, { ReactNode } from 'react';
import CAppPaper from '@/app/components/CAppPaper';

type CCardStatsChartProps = {
	title: string;
	chartComponent: ReactNode;
};

const CCardStatsChart = (props: CCardStatsChartProps) => {
	const { title, chartComponent } = props;

	const theme = useTheme();

	const styleTitle = {
		color: theme.palette.primary.main,
		verticalAlign: 'text-bottom',
		boxSizing: 'inherit',
		textAlign: 'left',
		alignItems: 'center',
		display: 'inline-flex',
		fontWeight: '500',
		fontSize: '1.25rem',
		textTransform: 'uppercase',
		'& .icon': {
			marginRight: '10px',
		},
	} as SxProps;

	const style = {
		padding: '30px',
		border: '0px',
		borderRadius: '10px',
		textAlign: 'center',
		'& .title': styleTitle,
	} as SxProps;

	return (
		<CAppPaper variant="outlined" sx={style}>
			<Box className="title">
				<AppCustomIcon tag="three_layers" className="icon" /> {title}
			</Box>
			<Box sx={{ height: '100%', display: 'flex', width: '100%', alignItems: 'center' }}>
				<Box sx={{ width: '100%' }}>{chartComponent}</Box>
			</Box>
		</CAppPaper>
	);
};

export { CCardStatsChart };
